var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColumnBarChartTemplate',{attrs:{"chartMainData":_vm.monthRegistrationDistribution,"chartHeight":314,"yearStart":2018,"chartOptionsFuncParams":_vm.chartOptionsFuncParams,"chartSeriesYKey":"totalUsers","chartTitle":"Статистика регистраций участников платформы"},on:{"year-update":_vm.yearUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }